module.exports = __webpack_public_path__ + "assets/images/project/head/Carvey_Ehren_Maigue.jpg?v=a97a1af9";